import React, { createContext, useContext } from 'react';
import ContentfulLoadError from '../../errors/ContentfulLoadError';
import { useMastheadData } from '../../utils/contentful';
const contextDefaults = {
    trackCat: '',
    onLinkClick: () => { },
    isFrodor: false,
    clientId: '',
    mastheadData: null,
    language: {
        locale: 'en-US',
        dir: 'ltr',
        onClick: () => { },
    },
    getLoginRedirectUri: () => 'https://artists.spotify.com/c',
};
const S4AMastheadContext = createContext(contextDefaults);
export const useS4AMastheadContext = () => {
    return useContext(S4AMastheadContext);
};
export const S4AMastheadProvider = ({ children, onLinkClick = contextDefaults.onLinkClick, isFrodor = contextDefaults.isFrodor, clientId = contextDefaults.clientId, trackCat = contextDefaults.trackCat, getLoginRedirectUri = contextDefaults.getLoginRedirectUri, language, }) => {
    const { data: mastheadData, error } = useMastheadData(language.locale);
    if (error) {
        throw new ContentfulLoadError(error);
    }
    return (React.createElement(S4AMastheadContext.Provider, { value: {
            onLinkClick,
            isFrodor,
            clientId,
            trackCat,
            mastheadData,
            language,
            getLoginRedirectUri,
        } }, children));
};
//# sourceMappingURL=S4AMastheadProvider.js.map